import apiClient from './apiClient'
import { buildApiV1Path } from '@/utils/apiPath'

export interface LoginRequest {
  username: string
  password: string
}

export interface LoginResponse {
  success: boolean
  message?: string
  error?: string
  user?: {
    id?: number
    sub?: string | number
    email?: string
    username?: string
    fullName?: string | null
    role?: string
    firstName?: string
    lastName?: string
    isActive?: boolean
    createdAt?: string
    updatedAt?: string
  }
  data?: {
    accessToken: string
    refreshToken: string
    expiresIn: number
    user: {
      id: number
      email: string
      username: string
      role: string
      fullName?: string | null
      firstName?: string
      lastName?: string
      isActive?: boolean
      createdAt?: string
      updatedAt?: string
    }
  }
}

export interface UserProfileResponse {
  success: boolean
  data: {
    id: number
    username: string
    email: string
    role: string
    fullName: string | null
    status: string
    createdAt: string
    lastLoginAt: string | null
  }
}

export const authService = {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>(buildApiV1Path('auth', 'login'), credentials)
    return response.data
  },

  async logout(refreshToken?: string): Promise<void> {
    try {
      const body = refreshToken ? { refreshToken } : undefined
      await apiClient.post(buildApiV1Path('auth', 'logout'), body)
    } catch (error) {
      console.error('Logout API call failed:', error)
    }
  },

  async getProfile(): Promise<UserProfileResponse> {
    const response = await apiClient.get<UserProfileResponse>(buildApiV1Path('auth', 'me'))
    return response.data
  },

  async refreshToken(refreshToken: string): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>(buildApiV1Path('auth', 'refresh'), { refreshToken })
    return response.data
  },

  async checkAuth(): Promise<boolean> {
    const token = localStorage.getItem('token')
    if (!token) {
      return false
    }

    try {
      await this.getProfile()
      return true
    } catch (error) {
      return false
    }
  },

  getAuthState() {
    const token = localStorage.getItem('token')
    const userStr = localStorage.getItem('user')

    return {
      token,
      user: userStr ? JSON.parse(userStr) : null,
    }
  },
}

export default authService
